import { render, staticRenderFns } from "./generateLink.vue?vue&type=template&id=21bac4ff&"
import script from "./generateLink.js?vue&type=script&lang=js&"
export * from "./generateLink.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports